import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, PaginationType } from "@lib/types/Api";
import { Note } from "@lib/types/Note";

// export const apiGetProvider = async (providerId: string) => {
//   const url = `/payment-hub-provider/${providerId}`;
//   return API.get<Provider>(url);
// };

export const apiGetNotes = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/payment-hub-note` });
  return API.get<PaginationType<Note>>(url);
};

export const apiAddNote = async (data: Partial<Note>) => {
  return API.post<Note>(`/payment-hub-note`, data);
};

export const apiDeleteNote = async (data: Note) => {
  return API.delete<null>(`/payment-hub-note/${data.id}`);
};

export const apiUpdateNote = async (data: Partial<Note>) => {
  const { id, ...rest } = data;
  return API.patch<Note>(`/payment-hub-note/${id}`, rest);
};
